import React, { Component } from 'react';
import { connect } from 'react-redux';

import Loading from '../../components/loading';
import { getURLParams } from '../lib/functions';

import {
  impersonateUser,
} from '../actions';

class Impersonate extends Component {
  componentWillMount() {
    const { impersonateUser, authentication } = this.props;

    if (this.queryString.id) {
      impersonateUser(this.queryString.id, authentication)
        .catch(() => {
          window.location = '/';
        })
        .then(() => {
          window.location = '/';
        });
    }
  }

  get queryString() {
    return getURLParams();
  }

  render() {
    if (!this.queryString.id) return window.location = '/';

    return (
      <Loading />
    );
  }
}

const mapDispatchToProps = {
  impersonateUser,
};

const mapStateToProps = (state) => {
  const { session: { authentication } } = state;

  return {
    authentication,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Impersonate);



// WEBPACK FOOTER //
// ./src/desktop/containers/impersonate.js